module.exports = __webpack_public_path__ + "static/media/logo-email.543087dc.svg";